module.exports = __webpack_public_path__ + "static/media/logomarca.a8184130.png";